import React from 'react';
import { Skeleton, SkeletonProps } from '@mui/material';

const LoadingPlaceholder: React.FC<SkeletonProps> = props => {
    return <Skeleton {...props} />;
};

export default LoadingPlaceholder;
